
import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navgation from './Navgation';
import Home from './Home';
import Footer from './Footer';
import Contact from './Contact';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Navgation/>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/Contact" element={<Contact />}/>
        <Route path='/*' element={<Home/>}/>    
      </Routes>
     <Footer/>
    </BrowserRouter>
    </div>
  );
}

export default App;
